/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const ArrowLeft: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M1.293 11.2929L9 3.58594L10.414 4.99994L4.414 10.9999H22C22.553 10.9999 23 11.4479 23 11.9999C23 12.5519 22.553 12.9999 22 12.9999H4.414L10.414 18.9999L9 20.4139L1.293 12.7069C0.901999 12.3159 0.901999 11.6839 1.293 11.2929Z'
      fill='currentColor'
    />
  </React.Fragment>
)
